import $ from 'jquery';
import addToCart from './addToCart';
import openCart from './openCart';
import generateHTML from './generateHTML';
import updateQuantity from './updateQuantity';
import { plusQuantity, minusQuantity } from './plusMinusQuantity';
import themeEditor from './themeEditor';

const SliderCart = () => {

  // Build the initial cart on load
  generateHTML();

  // Click the cart toggle and...you guessed it...toggle the cart open or closed
  $(document).on('click', '[data-cart-toggle]', () => {
    openCart(true);
  });

  // If someone comes to a page with #cart, open it immediately
  if (window.location.hash === '#cart') {
    $('[data-cart-toggle]').eq(0).trigger('click');
  }

  // Readjust position on breakpoint change if cart is open
  $(window).on('breakpointChange', () => {
    if (!$('[data-state]').hasClass('State--cart-open')) {
      return;
    }
    
    // Double click properly recalculates scrollbar where simply using adjustPositioning() would not.
    $('[data-cart-toggle]').eq(0).trigger('click');
    $('[data-cart-toggle]').eq(0).trigger('click');
  });

  // Add to cart form hijacking...this is where the magic happens
  $(document).on('submit', 'form[action^="/cart/add"]', (e) => {
    e.preventDefault();    
    addToCart($(e.currentTarget));
  });

  // Remove button
  $('[data-cart]').on('click', '[data-cart-remove]', (e) => {
    updateQuantity($(e.currentTarget).closest('.CartProduct').index(), 0);
  });

  // Change quantity
  $('[data-cart]').on('change', '[name="quantity"]', (e) => {
    updateQuantity($(e.currentTarget).closest('.CartProduct').index(), $(e.currentTarget).val());
  });

  $(document).on('click', '[data-quantity-plus]', plusQuantity);
  $(document).on('click', '[data-quantity-minus]', minusQuantity);

  themeEditor();
};

export {
  SliderCart,
};